var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.cmpMediaMasonry'] = (function () {
    'use strict';

    const initialize = (widget) => {
        masonryInit(widget);
        modalInit(widget);
    }

    const masonryInit = (widget) => {

        const masonryOptions = {
            itemSelector: ".cmp--mediaMasonry__masonry__button",
            columnWidth: ".cmp--mediaMasonry__masonry__sizer",
            percentPosition: true
        };

        const masonryBps = ["md", "lg", "xl", "xxl"];
        const masonryEl = widget.querySelector(".cmp--mediaMasonry__masonry");

        if (!masonryEl) return;

        // create Masonry instance
        let masonryInstance = new Masonry(masonryEl, masonryOptions);

        // Destroy layout if breakpoint is not included
        if (!masonryBps.includes(App.ZagBreakpoints.getBreakpoint())) {
            masonryInstance.destroy();
        }

        // Listen for breakpoint events
        window.addEventListener("enter-md", () => masonryInstance.layout());
        window.addEventListener("enter-sm", () => masonryInstance.destroy());
    }

    const modalInit = (widget) => {

        let videoIndex = null;
        const triggers = widget.querySelectorAll(".cmp--mediaMasonry__masonry__button button");
        const modalEl = widget.querySelector(".modal");
        const modal = new bootstrap.Modal(modalEl);
        const carouselEl = widget.querySelector(".splide");

        triggers.forEach(btn => {
            btn.addEventListener("click", function () {
                modal.show();
                videoIndex = this.getAttribute("data-video-index");
            });
        });

        modalEl.addEventListener("shown.bs.modal", () => {
            carousel(carouselEl, videoIndex);
            videoIndex = null;
        });
    }

    const carousel = (carousel, videoIndex) => {

        const splideOptions = {
            type: "loop",
            focus: "center",
            pagination: false,
            start: videoIndex
        };

        App.Helpers.splideFallback(
            carousel,
            splideOptions,
            (splide) => {
                splideEventBindings(splide, carousel, videoIndex);
            }
        );
    };

    const splideEventBindings = (splide, carousel, videoIndex) => {

        const status = carousel.querySelector(".splide__status");

        splide.on("mounted", () => {
            status.querySelector(".current").textContent = parseInt(videoIndex) + 1;
            status.querySelector(".divider").textContent = "/";
            status.querySelector(".total").textContent = splide.length;

            const slideEl = splide.Components.Slides.getAt(parseInt(videoIndex)).slide;
            const player = slideEl.querySelector(".cmp--multiMedia__video");

            if (player) {
                App.CmpMultiMedia.play(player);
            }

            splideEventBindingArrows(carousel);
            window.addEventListener("resize", () => splideEventBindingArrows(carousel));
        });

        splide.on('move', (newIndex) => {
            status.querySelector(".current").textContent = newIndex + 1;

            const iframes = carousel.querySelectorAll(".cmp--multiMedia__video iframe");
            iframes.forEach(iframe => {
                const multiMedia = iframe.closest(".cmp--multiMedia__video");
                if (multiMedia) {
                    App.CmpMultiMedia.stop(multiMedia);
                }
            });
        });
    };


    const splideEventBindingArrows = (carousel) => {

        const bps = ["lg", "xl", "xxl"];
        const media = carousel.querySelector(".cmp--multiMedia .cmp--multiMedia__media");
        const arrows = carousel.querySelectorAll("[class^='splide__arrow']");
        const status = carousel.querySelector(".splide__status");

        if (!media || !status) return;

        if (bps.includes(App.ZagBreakpoints.getBreakpoint())) {
            const top = media.offsetHeight / 2 + status.offsetHeight;
            arrows.forEach(el => {
                el.style.top = `${top}px`;
            });
        } else {
            arrows.forEach(el => {
                el.style.top = "";
            });
        }
    }

    return {
        initialize
    };

})();